import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, QueryList, ViewChildren } from "@angular/core";
import { EMPTY, empty, Subject, Subscription } from "rxjs";
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { Locations, LocationsEntity } from "src/app/location/location";
import { LocationService } from "src/app/location/location.service";
import { AuthService } from "src/app/auth.service";
import { DesignService } from "src/app/design/design.service";
import { Design, DesignsEntity, DesignsModel } from "src/app/design/design.model";
import { MessagerComponent } from "src/app/messager/messager/messager.component";
import { HvacSubmissionService } from "../../locationsubmission/hvacsubmission.service";
import { HvacsubmissionComponent } from "../../locationsubmission/hvacsubmission.component";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { switchMap, finalize, tap } from "rxjs/operators";


@Component({
  selector: "app-location",
  templateUrl: "./location.component.html",
  styleUrls: ["./location.component.css"],
})
export class HvacLocationComponent implements OnDestroy,AfterViewInit {
  private subscription$ = new Subscription();

  @ViewChildren('lastItem', {read: ElementRef})
  lastItem:QueryList<ElementRef>;

  showLoader: boolean = true;
  designs: DesignsEntity[];
  totalpages: number;
  currentPage: number = 0;
  allLocations: any[] = [];




  term$ = new Subject<string>();

  private searchSubscription: Subscription;

  observer:any;

  constructor(
    private locationService: LocationService,
    private designService: DesignService,
    private snackBar: MatSnackBar,
    public auth: AuthService,
    public messager: MessagerComponent,
    public dialog: MatDialog,
    public submissionService: HvacSubmissionService
  ) {


    this.searchSubscription = this.term$.pipe(
      debounceTime(1000),
      switchMap(term => {
        console.log(term);
        //add loader

        this.searchLocations();
        /*do something*/
        return EMPTY;
      })
    ).subscribe();

  }


  ngAfterViewInit(): void {
    this.lastItem.changes.subscribe((item) => {
      if(item.last){
        this.observer.observe(item.last.nativeElement);
      }
    })
    //throw new Error("Method not implemented.");
  }

  intersectionObserver(): void {

    let options = {
      root:null,
      rootMargin: '0px',
      threshold: 0.4,
    }

    this.observer = new IntersectionObserver((entries) => {
      if(entries[0].isIntersecting && !this.searchLocation) {
        console.log("scroll'd");

        if(this.currentPage < this.totalpages){
          this.currentPage++;
          this.getLocationList();
          console.log('less than');
        }
      }

    },options)

  }

  searchLocation: string | number | any | null;
  locations: any[] = [];
  systemsDesigns: DesignsModel;
  filterDesigns: DesignsEntity[];



  ngOnInit() {
    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.getLocationList();
          this.getDesignList();
          this.intersectionObserver();

          this.subscription$.add(
            this.locationService.getLocationsAll().subscribe(
              (res:any) => {
                console.log(res);
                this.allLocations = res.Locations;
              }, err => {
                //console.log(err);
              }
            )
          )

        }
      },
      (err) => {
        this.showLoader = false;
        this.snackBar.open(
          `Error in Getting Designer and Contractor Details`,
          "",
          {
            duration: 2000,
          }
        );
      }
    );



    //getAllLocations






  }

  /**
   * Get Locations List
   */
  getLocationList() {
    this.showLoader = true;
    this.subscription$.add(
      this.locationService.getLocationList(this.currentPage).subscribe(
        (result: Locations) => {
          console.log(result);
          this.totalpages = result.Pages;
          this.showLoader = false;

          result.Locations.forEach((l) => {
            this.locations.push(l)
          })

          //this.locations = result.Locations.map(location => ({ ...location, selectedDesign: '' }));
          //setTimeout(() => {this.showLoader = false}, 2000);
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Location List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
 * Get Design List
 */
  getDesignList() {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getDesignList().subscribe(
        (result: Design) => {
          this.designs = result.Designs;
          this.filterDesigns = result.Designs;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  doSpinner() {
    let element = document.getElementById('theSearch');
    element.classList.add('loading');
  }

  removeSpinner() {
    let element = document.getElementById('theSearch');
    element.classList.remove('loading');
  }

  /**
   *
   * @param searchDesign search design in design list
   */
  searchDesign(searchDesign: any) {
    let data = searchDesign.target.value.toLocaleLowerCase();
    this.designs = this.filterDesigns.filter((searchData: DesignsEntity) => {
      return (searchData?.name?.toLocaleLowerCase().match(data))
    })
  }
  /**
   *
   * @param
   * display selected design name in autoComplete dropdown
   * @returns
   */
  displaySelectedDesigns(selectedDesign: any) {
    return selectedDesign?.name
  }

  /**
   * Add design on selected Location
   * @param selectedDesign
   * @param selectedLocation
   */

  onDesignSelection(selectedDesign: DesignsEntity, selectedLocation: LocationsEntity, index) {

    let locationService = this.locationService;
    let locList = this.getLocationList;

    let prom = new Promise(function(resolve, reject){
      locationService.selectedDesignLocation(selectedDesign, selectedLocation,true);
      //resolve('done');
      setTimeout(() => resolve("Picked!"), 2000);
    }).then(()=> {
      console.log(this.locations);
      const newLocList = this.locations.slice(0);

      newLocList.splice(index, 1);
      this.locations = newLocList;

      //this.getLocationList();
      console.log('done.');
    })

  }
  /**
   * Search For Specific Location
   */
  searchLocations() {
    if (this.searchLocation !== "") {
      this.showLoader = true;
      let searchValue = this.searchLocation.toLocaleLowerCase();
      console.log(searchValue);
      this.locations = this.allLocations.filter((location: LocationsEntity) => {
        return (
          location.subdivision_name.toLocaleLowerCase().match(searchValue) ||
          location.street_address.toLocaleLowerCase().match(searchValue) ||
          location.city.toLocaleLowerCase().match(searchValue) ||
          location.lot.toLocaleLowerCase().match(searchValue) ||
          location.plan_name.toLocaleLowerCase().match(searchValue)
        );
      });
      this.showLoader = false;
      this.removeSpinner();
    } else {
      this.removeSpinner();
      this.locations = [];
      this.currentPage = 0;
      this.getLocationList();
    }
  }

  checkValues(designe: DesignsModel, location) {


    console.log(designe);
    console.log(location);
    let rwa, rcfa, rbed;
    let message = "";
    let count = 0;
    //get wa, cfa and bedrooms from plans table
    this.locationService.getRaterHvacReview(location.plan).subscribe(
      (res)=> {

        //console.log(res);
        rwa = res.Plan?.windowarea || 0;
        rcfa = res.Plan?.cfa || 0;
        rbed = res.Plan?.bedrooms || 0;

        this.submissionService.getOneDesign(location.selectedDesign.id).subscribe(
          (res) => {

            //let design = res;
        //console.log(res);

        if(  !(parseInt(res.hvac[0].cfa) >= (rcfa - 100) && parseInt(res.hvac[0].cfa) <= (parseInt(rcfa) + 300)) ){

          count += 1;
          message += '* The current design\'s CFA may be out of range: \n \t Rater CFA: ' + rcfa + ' \n \t Current design CFA: ' + parseInt(res.hvac[0].cfa) + ' \n';
      }

      if(rwa < 500){
        if(  !(parseInt(res.hvac[0].wa) >= (rwa - 15) && parseInt(res.hvac[0].wa) <= (rwa + 60)) ){
          count += 1;
          message += '* The current design\'s  window area may be out of range: \n \t Rater WA: ' + rwa + ' \n \t Current design WA: ' + res.hvac[0].wa + '\n';
        }
      }
      else{
        if(  !(parseInt(res.hvac[0].wa) >= (parseInt(rwa) - (parseInt(rwa) * 0.03)) && parseInt(res.hvac[0].wa) <= (parseInt(rwa) + (parseInt(rwa) * 0.12 ) )) ){
          count += 1;
          message += '* The current design\'s window area may be out of range: \n \t Rater WA: ' + rwa + ' \n \t Current design WA: ' + res.hvac[0].wa + '\n';
        }
      }

      if(  !(Math.abs(parseInt(res.hvac[0].noocupants) - parseInt(rbed)) <= 2)){
        count += 1;
        message += '* The current design\'s number of occupants may be out of range: \n \t Rater #: ' + rbed + ' \n \t Current design #: ' + res.hvac[0].noocupants + '\n';
      }

      if(count > 0){

        const dialogRef = this.dialog.open( ConfirmWarningDialogComponent, {
          height: '380px',
          width: '500px',
          data: {
            message: message
          }

        });

      }

          }, err => {
            console.log('Could not load design')
          }



        )
      }, err => {
        console.log('Could not load rater plan.')

      }

    )

  }

  resetSubmission(loc){

    const dialogRef = this.dialog.open( ResetDialogComponent, {
      height: '240px',
      width: '300px'
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == 1){
          console.log('closed: 1');

          //reset here

          this.locationService.resetLocation(loc.location_id).subscribe(
            (res) => {
              this.messager.openSnackBar(loc.street_address +  ' has been reset', '' , 'successAlert');
              this.getLocationList();
            }, err => {
              this.messager.openSnackBar('Error' + err.message, '' , 'errorAlert');
              console.log(err);
            }
          )


        }
        else {
          console.log('closed 2');
        }
      }, err => {

      }
    )

  }



  openSubmissionModal(location, index) {


      ///get submitted data
      let hid = location.hvac_design_id;
      let lid = location.location_id;
      let sData: any;

    document.getElementById('main-nav').style.display = 'none';

      this.submissionService.getSubmittedHVAC(lid).subscribe(

        (res)=>{

          if(res.Rows == 0){

            this.submissionService.getHvacData(lid).subscribe(

              (res)=> {

                if(res.Rows == 0){
                  console.log(res);
                  this.submissionService.getHVACdataLegacy(lid).subscribe(

                    (res)=> {
                      console.log(res);
                      sData = res.hvacData;
                      sData.plan_id = location.plan;

                      const dialogRef = this.dialog.open( HvacsubmissionComponent, {
                        panelClass: 'hvacPopup',
                        data: {
                          submittedData : sData
                        },

                      });
                      dialogRef.afterClosed().subscribe(result => {
                      document.getElementById('main-nav').style.display = 'block';

                        if (result === 1) {
                         this.locationService.updateErrorsFalse(location.location_id).subscribe(
                           (res)=> {
                            console.log(res);
                           },err => {
                            console.log(err);
                           }
                         );

                         console.log(this.locations);
                         const newLocList = this.locations.slice(0);

                         newLocList.splice(index, 1);
                         this.locations = newLocList;
                        this.messager.openSnackBar('Successfully resubmitted for review!', '', 'successAlert');

                          //this.locationService.deleteLocation(location.location_id);
                        }
                      })
                    }, err => {
                      this.messager.openSnackBar('Failed', '', 'errorAlert');
                    });

                } else {
                  sData = res.hvacData;
                  console.log(res);

                  sData.plan_id = location.plan;

                  const dialogRef = this.dialog.open( HvacsubmissionComponent, {
                    panelClass: 'hvacPopup',
                    data: {
                      submittedData : sData
                    },

                  });
                  dialogRef.afterClosed().subscribe(result => {
                    document.getElementById('main-nav').style.display = 'block';

                    //this.onDesignSelection(location.hvac_design_id, location,index);


                      //this.getLocationList();
                      console.log('done.');
                    if (result === 1) {
                      this.locationService.updateErrorsFalse(location.location_id).subscribe(
                        (res)=> {
                         console.log(res);
                        },err => {
                         console.log(err);
                        }
                      );
                      //this.locationService.deleteLocation(location.location_id);
                      console.log(this.locations);
                      const newLocList = this.locations.slice(0);
                      this.messager.openSnackBar('Successfully resubmitted for review!', '', 'successAlert');

                      newLocList.splice(index, 1);
                      this.locations = newLocList;
                    }
                  })

                }
              }, err => {

              });
          } else {
            sData = res.hvacData;
            console.log(res);

            sData.forEach(function(e){
              e.condensermn = e.condmn;
              e.evapmn = e.evaporator;
              e.furnacemn = e.furnmn;
            })

            console.log(sData);

            sData.plan_id = location.plan;

            const dialogRef = this.dialog.open( HvacsubmissionComponent, {
              panelClass: 'hvacPopup',
              data: {
                submittedData : sData
              },

            });
            dialogRef.afterClosed().subscribe(result => {
              document.getElementById('main-nav').style.display = 'block';


              if (result === 1) {

                this.locationService.updateErrorsFalse(location.location_id).subscribe(
                  (res)=> {
                   console.log(res);
                  },err => {
                   console.log(err);
                  }
                );
                console.log(this.locations);
                const newLocList = this.locations.slice(0);
                this.messager.openSnackBar('Successfully resubmitted for review!', '', 'successAlert');

                newLocList.splice(index, 1);
                this.locations = newLocList;
                //this.locationService.deleteLocation(location.location_id);
              }
            })


          }


        }, err => {
            this.messager.openSnackBar('Failed', '', 'errorAlert');
        }


      )

        console.log(sData);
      //for now, open the form





  }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}

@Component({
  template: `
    <h1 mat-dialog-title>Reset?</h1>
    <div>
      This will remove your design completely so that you may select a different one.
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button style="background: red;color: white;" (click)="dref.close(1)" mat-dialog-close='1' >Reset</button>
      <button mat-button (click)="dref.close(2)" mat-dialog-close='2' style="margin-left: 40px;background: #ffffffaf;">Cancel</button>
    </div>
  `
})
export class ResetDialogComponent {

  constructor(public dref: MatDialogRef<ResetDialogComponent>){


  }

}

@Component({
  template: `
    <h1 mat-dialog-title style="text-align:center;">Warning!</h1>
    <div>
      <pre style="white-space: break-spaces;">{{data.message}}</pre>
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button (click)="dref.close()"  style="position: relative;left: 50%;background: #ffffffaf;">Close</button>
    </div>
  `
})
export class ConfirmWarningDialogComponent {

  constructor(public dref: MatDialogRef<ConfirmWarningDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data:any){}

}


